import React from 'react'
import { Select } from 'antd'

export const aspectOptions = [{ value: '16:9', label: '16:9 — Landscape (default)' }, { value: '9:16', label: '9:16 — Portrait' }]
export const storyboardRatio = (record) => record?.aspectRatio || '3:2'
export const videoRatio = (record) => record?.aspectRatio || '16:9'
export const mediaAspectClass = (ratio) => ratio === '9:16' ? 'aspect-[9/16]' : ratio === '3:2' ? 'aspect-[3/2]' : 'aspect-video'
export const videoClass = (record) => `object-contain max-h-[70vh] ${mediaAspectClass(videoRatio(record))}`

const AspectRatioSelect = ({ value = '16:9', onChange, disabled, legacy = false }) => <div className="min-w-0">
  <label className="block font-bold text-[14px] mb-2">Aspect ratio</label>
  <Select aria-label="Aspect ratio" className="w-full" size="large" value={value} onChange={onChange} disabled={disabled}
    options={legacy ? [...aspectOptions, { value: '3:2', label: '3:2 — Original landscape' }] : aspectOptions} />
</div>
export default AspectRatioSelect